const waitForElm = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

const Utils = ($) => {
  const body = document.querySelector("body");
  const isAdmin = body.classList.contains("wp-admin");
  let editor;
  let vw;
  let vh;

  const refresh = () => {
    if (isAdmin) {
      const editorRect = editor.getBoundingClientRect();
      vw = editorRect.width / 100;
    } else {
      vw = body.clientWidth / 100;
    }
    // vw = isAdmin ? this.editor.getBoundingClientRect().width / 100 : body.clientWidth / 100;
    body.style.setProperty(`--vw`, `${vw}px`);

    vh = window.innerHeight / 100;
    body.style.setProperty(`--vh`, `${vh}px`);
  };

  const resizeObserver = new ResizeObserver(() => {
    refresh();
  });

  if (!isAdmin) {
    refresh();
    window.addEventListener("resize", () => {
      refresh();
    });
  } else {
    $(window).on("load", function () {
      waitForElm(".edit-post-visual-editor").then((elm) => {
        resizeObserver.observe(elm);
      });
      editor = document.querySelector(".edit-post-visual-editor");
    });
  }
};

export default Utils;
